// TODO - do we need this!?

import React from 'react';

export const AppSettings = React.createContext();